import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useSelector, useDispatch } from "react-redux";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import {
  fetchDesignation,
} from "../../redux/actions/designationAction";
import {
  fetchInstituteData,
} from "../../redux/actions/getInstitutesAction";
import {
  fetchCompanyData,
} from "../../redux/actions/getCompaniesAction";

function EditCandid() {
  const sessionId = localStorage.getItem("sessionId");

  // ...............................PROFILE Start.......................................
  const [displays, setDisplays] = useState(false);
  const [headLine, setHeadLine] = useState("");
  const [website, setWebsite] = useState("");
  const [about, setAbout] = useState("");
  const [curretactive, setCurretactive] = useState("");
  const [orgType, setOrgType] = useState("");

  // ...............................PROFILE End.......................................

  const AddProfile = async () => {
    setDisplays(true);

    if (!curretactive || !orgType) {
      toast.error("Please fill all required fields.");
      return;
    }

    if (orgType === "1" && !instituteId && !headLine && !website && !about) {
      toast.error("Please select an Institution.");
      return;
    } else if (orgType !== 1 && orgType !== 4) {
      if (
        !companyId &&
        !designationId &&
        !headLine &&
        !website &&
        !about
      ) {
        toast.error("Please fill all required fields.");
        return;
      }
    }
    let body = {
      sessionId: sessionId,
      currentlyActiveAs: curretactive,
      orgType: String(orgType),
    };

    if (orgType === "1") {
      body.insttnId = instituteId;
      body.compId = null;
      body.dsgntnId = null;
      body.headLine = headLine;
      body.about = about;
      body.website = website;
    } else {
      body.insttnId = null;
      body.compId = companyId;
      body.dsgntnId = designationId;
      body.headLine = headLine;
      body.about = about;
      body.website = website;
    }

    try {
      const dandidate = await axios.post("/CandidateData/add", body);
      toast.success(dandidate.data.message);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  const UpdateProfile = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    try {
      setDisplays(true);

      // Input validation (same logic as AddProfile)
      if (!curretactive || !orgType) {
        toast.error("Please fill all required fields.");
        return;
      }

      if (orgType === "1" && !instituteId && !headLine && !website && !about) {
        toast.error("Please select an Institution.");
        return;
      } else if (orgType !== "1") {
        if (
          !companyId &&
          !designationId &&
          !headLine &&
          !website &&
          !about
        ) {
          toast.error("Please fill all required fields.");
          return;
        }
      }

      let body = {
        sessionId: sessionId,
        currentlyActiveAs: curretactive,
        orgType: String(orgType),
      };

      if (orgType === "1") {
        body.insttnId = instituteId;
        body.compId = null;
        body.dsgntnId = null;
        body.headLine = headLine;
        body.about = about;
        body.website = website;
      } else {
        body.insttnId = null;
        body.compId = companyId;
        body.dsgntnId = designationId;
        body.headLine = headLine;
        body.about = about;
        body.website = website;
      }
      // API request to update the profile
      const res = await axios.post("/CandidateData/Update", body);


      // Show success message and reset form fields
      toast.success(res.data.message);
      setCompanyId("");
      setInstituteId("");
      setHeadLine("");
      setWebsite("");
      setAbout("");
      setDisplays(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  const Profile = async (e) => {
    e.preventDefault();
    const profileExists = await checkProfile();
    if (profileExists) {
      UpdateProfile(e);
    } else {
      AddProfile();
    }
  };


  const checkProfile = async () => {
    const data = { sessionId: sessionId };
    try {
      const response = await axios.post("/CandidateData/Check", data);
      const profileExists = response.data.responseData;

      return profileExists;
    } catch (error) {
      console.error("Error fetching profile status:", error);
      return false;
    }
  };

  useEffect(() => {
    checkProfile();
  }, []);

  // .............................. designation Dropdown ...............................
  const dispatch = useDispatch();

  const [designationSearch, setDesignationSearch] = useState("");
  const [designationId, setDesignationId] = useState(null);
  const { designationList } = useSelector(
    (state) => state.designation
  );

  useEffect(() => {
    dispatch(fetchDesignation());
  }, [dispatch]);

  const handleDesignation = (selectedOption) => {
    if (selectedOption) {
      setDesignationId(selectedOption.value);
      // dispatch(selectDesignation(selectedOption.value));
    }
  };
  
  // ...............................Designation Dropdown.......................................

  // ...............................Institute Dropdown.......................................
  const [instituteSearch, setInstituteSearch] = useState("");
  const [instituteId, setInstituteId] = useState(null);
  const { getinstituteList } = useSelector(
    (state) => state.institute
  );
  useEffect(() => {
    dispatch(fetchInstituteData());
  }, [dispatch]);

  const handleInstitute = (selectedOption) => {
    if (selectedOption) {
      setInstituteId(selectedOption.value);
    }
  };
  // ...............................Institute Dropdown.......................................

  // ...............................Company Dropdown.......................................
  const [companySearch, setCompanySearch] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const { getcompaniesList } = useSelector(
    (state) => state.getcompanies
  );

  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleCompany = (selectedOption) => {
    if (selectedOption) {
      setCompanyId(selectedOption.value);
    }
  };
  // ...............................company Dropdown.......................................

  return (
    // Prifile setting...................START.........................

    <div className="main-container edit-candi pb-5 settings">
      <div className="content-wrapper">
        <div className="title delete-title ">
          <h1>
            {" "}
            <span className="orange-box"></span> Candidate
          </h1>
        </div>



        <div className="card delete-card  d-flex align-center">
          <div className="post-job-details-form Edit-Card-details-form">
            <div className="post-form-row">
              <div className="post-form-group">
                <label htmlFor="category">Currently Active</label>
                <select
                  id="currentactive"
                  className="form-control"
                  placeholder="value"
                  required
                  onChange={(e) => setCurretactive(e.target.value)}
                  value={curretactive}
                  invalid={displays && curretactive === ""}
                >
                  <option value="Default Value">Select here</option>
                  <option value="1">Student</option>
                  <option value="2">Professional</option>
                </select>
                {displays && !curretactive ? (
                  <span className="error_msg_lbl text-red">
                    Enter Currently Active
                  </span>
                ) : null}
              </div>

              <div className="post-form-group">
                <label htmlFor="tag">Organization Type</label>
                <select
                  className="form-control"
                  onChange={(e) => setOrgType(e.target.value)}
                  value={orgType}
                  id="Orgtype"
                  placeholder="Organization Type"
                  required
                  styles={customStyles}
                  invalid={displays && orgType === ""}
                >
                  <option value="Default Value">Select here</option>
                  <option value="1">Institution</option>
                  <option value="2">Company</option>
                </select>

                {displays && !orgType ? (
                  <span className="error_msg_lbl text-red">
                    Enter Organization Type
                  </span>
                ) : null}
              </div>
            </div>

            {/* Conditionally render additional fields based on organization type */}
            {orgType && (
              <div>
                {orgType === "1" ? (
                  <>
                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="jobApplyType">Institution</label>
                        <ReactSelect
                          options={getinstituteList}
                          onChange={handleInstitute}
                          value={
                            getinstituteList.find(
                              (option) => option.value === instituteId
                            ) || null
                          }
                          placeholder="Select Institute Type"
                          styles={customStyles}
                          classNamePrefix="react-select"
                          className="form-control"
                          onInputChange={(inputValue) =>
                            setInstituteSearch(inputValue)
                          }
                          invalid={displays && instituteSearch === ""}
                        />
                        {displays && !instituteId ? (
                          <span className="error_msg_lbl text-red">
                            Enter Institution
                          </span>
                        ) : null}
                      </div>
                      <div className="post-form-group">
                        <label htmlFor="minSalary">HeadLine</label>
                        <input
                          type="text"
                          id="minSalary"
                          placeholder="HeadLine"
                          required
                          onChange={(e) => setHeadLine(e.target.value)}
                          value={headLine}
                          invalid={displays && headLine === ""}
                        />
                        {displays && !headLine ? (
                          <span className="error_msg_lbl text-red">
                            Enter HeadLine
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="experience">Website</label>
                        <input
                          type="text"
                          id="experience"
                          placeholder="Website"
                          onChange={(e) => setWebsite(e.target.value)}
                          value={website}
                          invalid={displays && website === ""}
                        />
                        {displays && !website ? (
                          <span className="error_msg_lbl text-red">
                            Enter Website
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="maxSalary">About</label>
                        <textarea
                          type="text"
                          id="maxSalary"
                          placeholder="About"
                          onChange={(e) => setAbout(e.target.value)}
                          value={about}
                          invalid={displays && about === ""}
                        />
                        {displays && !about ? (
                          <span className="error_msg_lbl text-red">
                            Enter About
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="gender">Company</label>
                        <ReactSelect
                          options={getcompaniesList}
                          onChange={handleCompany}
                          value={
                            getcompaniesList.find(
                              (option) => option.value === companyId
                            ) || null
                          }
                          placeholder="Select Company Type"
                          styles={customStyles}
                          classNamePrefix="react-select"
                          className="form-control"
                          onInputChange={(inputValue) =>
                            setCompanySearch(inputValue)
                          }
                          invalid={displays && companySearch === ""}
                        />
                        {displays && !companyId ? (
                          <span className="error_msg_lbl text-red">
                            Enter Company
                          </span>
                        ) : null}
                      </div>

                      <div className="post-form-group">
                        <label htmlFor="externalUrl">Designation</label>
                        <ReactSelect
                          options={designationList}
                          onChange={handleDesignation}
                          value={
                            designationList.find(
                              (option) => option.value === designationId
                            ) || null
                          }
                          placeholder="Select Designation Type"
                          styles={customStyles}
                          classNamePrefix="react-select"
                          className="form-control"
                          onInputChange={(inputValue) =>
                            setDesignationSearch(inputValue)
                          }
                          invalid={displays && designationSearch === ""}
                        />
                        {displays && !designationId ? (
                          <span className="error_msg_lbl text-red">
                            Enter Designation
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="minSalary">HeadLine</label>
                        <input
                          type="text"
                          id="minSalary"
                          placeholder="HeadLine"
                          required
                          onChange={(e) => setHeadLine(e.target.value)}
                          value={headLine}
                          invalid={displays && headLine === ""}
                        />
                        {displays && !headLine ? (
                          <span className="error_msg_lbl text-red">
                            Enter HeadLine
                          </span>
                        ) : null}
                      </div>
                      <div className="post-form-group">
                        <label htmlFor="experience">Website</label>
                        <input
                          type="text"
                          id="experience"
                          placeholder="Website"
                          onChange={(e) => setWebsite(e.target.value)}
                          value={website}
                          invalid={displays && website === ""}
                        />
                        {displays && !website ? (
                          <span className="error_msg_lbl text-red">
                            Enter Website
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="post-form-row">
                      <div className="post-form-group">
                        <label htmlFor="maxSalary">About</label>
                        <textarea
                          type="text"
                          id="maxSalary"
                          placeholder="About"
                          onChange={(e) => setAbout(e.target.value)}
                          value={about}
                          invalid={displays && about === ""}
                        />
                        {displays && !about ? (
                          <span className="error_msg_lbl text-red">
                            Enter About
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="avatar-upload-container">
              <button className="save-button" onClick={(e) => Profile(e)}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditCandid;
